import { AnswerSubCategory } from "@/schema/console/evaluation-reports/AnswerSubCategory";
import QuestionRow from "@/src/console/(auth)/_components/AssessmentResultDialog/QuestionList/QuestionRow";
import { QuestionCircle20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface QuestionListProps {
  answerSubCategory: AnswerSubCategory;
}

function QuestionList({ answerSubCategory }: QuestionListProps) {
  const questionCount = answerSubCategory.answer_contents.length;
  const { t } = useTranslation();
  return (
    <div className=" flex flex-col">
      <div className=" flex flex-col space-y-2 p-5 border-b border-cool-gray-200">
        <p className=" text-lg font-medium text-cool-gray-700">
          {answerSubCategory.content}
        </p>
        <div className=" flex flex-row space-x-[6px] items-center">
          <QuestionCircle20Regular />
          <p className=" text-sm font-normal text-cool-gray-600">
          {`${questionCount} ${t("questions")}`}
          </p>
        </div>
      </div>
      {answerSubCategory.answer_contents.map((answerContent, index) => (
        <QuestionRow
          key={index}
          index={index + 1}
          answerContent={answerContent}
        />
      ))}
    </div>
  );
}

export default QuestionList;
